/* Rolex/RCPO jQuery binding fix.
 * The rolex-product-form (rendered on Rolex product pages) loads Prototype.js and a CDN jQuery via
 * in-body <script> tags that reassign window.$ — leaving window.$ as a non-jQuery $ (Prototype: no .off,
 * and $('css-selector') resolves via getElementById -> null), while window.jQuery stays the theme's
 * full jQuery (with the Flickity/fancybox/zoom plugins added by vendors.min.js). sectionsnew.js and
 * rolex-custom.js use the GLOBAL $, so they throw "$(...).off is not a function" and ".each/.click/
 * .hasClass on null", which aborts productPage.init() and stops rolex-custom.js mid-file.
 * This file is loaded (deferred) as the FIRST bundle in the Rolex/RCPO gate, so it runs AFTER the form's
 * in-body sync scripts but BEFORE vendors/sectionsnew/utilities/app and rolex-custom.js execute — making
 * the full jQuery the active $ for all of them. Only acts when $ is broken; no-op when $ is already jQuery. */
(function () {
  function fix() {
    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.off === 'function' &&
        (typeof window.$ !== 'function' || !window.$.fn || typeof window.$.fn.off !== 'function')) {
      window.$ = window.jQuery;
    }
  }
  fix();
  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fix);
    window.addEventListener('load', fix);
  }
})();
